import React, { useEffect, useState } from 'react';
const useSelectPaymentMethod = (selectedRows) => {
  const [cheque, setCheque] = useState([]);
  const [eft, setEft] = useState([]);
  const [creditCard, setCreditCard] = useState([]);

  useEffect(() => {
    const chequeRows = [];
    const eftRows = [];
    const creditCardRows = [];

    selectedRows.forEach(({ original }) => {
      if (original?.billingType === 'Cheque') {
        chequeRows.push(original);
      } else if (original?.billingType === 'EFT') {
        eftRows.push(original);
      } else if (original?.billingType === 'Credit Card') {
        creditCardRows.push(original);
      }
    });

    setCheque(chequeRows);
    setEft(eftRows);
    setCreditCard(creditCardRows);
console.log("🚀 ~ useEffect ~ creditCardRows:", creditCardRows);
console.log("🚀 ~ useEffect ~ chequeRows:", chequeRows);
console.log("🚀 ~ useEffect ~ eftRows:", eftRows);

  }, [selectedRows]);

  return {
    cheque,
    eft,
    creditCard,
  };
};

export default useSelectPaymentMethod;
